"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PromoPanelState_1 = require("./PromoPanelState");
var promoStyles = require("./PromoPanel.scss");
var ui_components_1 = require("@idp/ui-components");
var styles = require("../../CartConfigurationContainer/CartConfiguration.scss");
var icons = require("../../../styles/ccc-icons-cart.scss");
var YourSavingsCard_1 = require("./YourSavingsCard");
var PromoCard_1 = require("./PromoCard/PromoCard");
var StateProvider_1 = require("../../../api/StateProvider");
var utils_1 = require("@idp/ui-components/utils");
var components_1 = require("@idp/duc/components");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var Utils = require("../../../utils/UtilityFunctions");
var CartUtils = require("../../../utils/CartUtilFunctions");
var CloserCoupon_1 = require("../../CartLob/shared/CloserCoupon");
var RetailerOffer_1 = require("../RetailerOffer/RetailerOffer");
var basePanelOptions = { backgroundColor: '#FFF' };
var PromoPanel = /** @class */ (function (_super) {
    __extends(PromoPanel, _super);
    function PromoPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new PromoPanelState_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.initializeEvents();
        _this.getPromoContainer = _this.getPromoContainer.bind(_this);
        _this.checkAndUpdateDataFromStateManager = _this.checkAndUpdateDataFromStateManager.bind(_this);
        _this.savingsCardData = {
            hideTotalMonthlySavings: false,
            promotionArr: [],
            rewardsArr: [],
            totalMonthlySavings: 0,
            totalOneTimeSavings: 0,
            totalSavingsToday: 0,
        };
        return _this;
    }
    PromoPanel.prototype.componentDidMount = function () {
        this.payload = Utils.getCartResp();
        this.isExpUp = CartUtils.isExpupgradeViewEnable();
        if (this.payload && this.payload.metadata && this.payload.metadata.metadata) {
            this.showPromoSection = this.payload.metadata.metadata.couponFlag;
            this.showRepCodeSection = this.payload.metadata.metadata.repCodeFlag;
        }
        if (this.showPromoSection || this.showRepCodeSection) {
            this.setState({ showPromoCart: true });
        }
        else {
            this.setState({ showPromoCart: false });
        }
        if ((this.savingsCardData.totalOneTimeSavings > 0) ||
            (this.savingsCardData.totalMonthlySavings > 0) ||
            (this.savingsCardData.rewardsArr.length > 0) ||
            (this.savingsCardData.promotionArr.length > 0) ||
            this.state.isPanelError) {
            this.setState({ showMySaving: true });
        }
        else {
            this.setState({ showMySaving: false });
        }
        this.checkURLforCoupon();
    };
    PromoPanel.prototype.render = function () {
        var promoPanelTexts = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.promoPanel;
        this.checkAndUpdateDataFromStateManager();
        var showBauPromoPanel = true;
        if (this.props && this.props.options && this.props.options.isNewSavingsPromoComponent) {
            showBauPromoPanel = false;
        }
        else {
            showBauPromoPanel = true;
        }
        var promoContainer = Utils.IsAccessoryOnlyInCart() ? promoStyles.accPromoLink :
            promoStyles.promoContainer;
        return (React.createElement(React.Fragment, null,
            showBauPromoPanel && React.createElement("div", { className: this.isExpUp ? '' : styles.containerBorder }, this.props.data.cartPage ?
                this.getPromoContainer(promoPanelTexts) :
                (React.createElement("div", { className: styles.container },
                    React.createElement("div", { className: styles.cartContainer }, this.getPromoContainer(promoPanelTexts))))),
            this.props && this.props.data && this.props.data.displayCloserCoupon &&
                React.createElement(CloserCoupon_1.default, { events: { applyCoupon: this.applyCloserCoupon,
                        showSaveCartModal: this.props.events.showSaveCartModal } }),
            !showBauPromoPanel && (this.state.showMySaving || this.savingsCardData.promotionArr.length > 0
                || this.savingsCardData.rewardsArr.length > 0) &&
                React.createElement(YourSavingsCard_1.default, { "data-test-id": utils_1.default('Message', 'Cart', 'SavingContent'), data: this.savingsCardData, events: this.yourSavingsCardEvents, options: { isNewSavingsComponent: true } }),
            !showBauPromoPanel && (this.state.showPromoCart ||
                (this.state.autoApplyCouponCode && this.state.autoApplyCouponCode.couponCode)) &&
                React.createElement("div", { className: promoContainer },
                    React.createElement("div", { className: promoStyles.innerDivider }),
                    React.createElement(PromoCard_1.default, { data: { autoApplyCouponCode: this.state.autoApplyCouponCode }, events: this.promoCardEvents, options: {
                            autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                            isExpressUp: this.isExpUp,
                        } }))));
    };
    PromoPanel.prototype.showRetailerOffer = function (losg) {
        var _a, _b, _c;
        this.payload = Utils.getCartResp();
        var rewardPromo;
        var promotion = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.promotions;
        var retailer = (_c = (promotion)) === null || _c === void 0 ? void 0 : _c.map(function (promo) {
            var _a;
            if (rewardPromo) {
                return;
            }
            else {
                if (((_a = promo === null || promo === void 0 ? void 0 : promo.promotionType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'REWARD' && (promo === null || promo === void 0 ? void 0 : promo._dealerPromotion)) {
                    rewardPromo = promo;
                    return React.createElement(RetailerOffer_1.default, { isReawardCard: true, losg: losg, promotion: rewardPromo });
                }
            }
        });
        return React.createElement("div", null, retailer);
    };
    PromoPanel.prototype.checkAndUpdateDataFromStateManager = function () {
        var _this = this;
        this.payload = Utils.getCartResp();
        var lobList = Utils.getLobList();
        if (this.payload) {
            if (this.payload.wirelessCart ||
                this.payload.broadbandCart) {
                var couponCodeArr = this.getCouponCodeArr();
                this.savingsCardData.promotionArr = couponCodeArr.filter(function (promotion) {
                    if (promotion.couponCode) {
                        return true;
                    }
                    return false;
                });
            }
            if (this.payload && this.payload.orderPriceInfo) {
                this.savingsCardData.totalSavingsToday =
                    this.payload.orderPriceInfo.totalSavingsToday;
                this.savingsCardData.totalMonthlySavings =
                    this.payload.orderPriceInfo.totalMonthlySavings;
                if (lobList) {
                    Object.values(lobList).forEach(function (element) {
                        var _a;
                        if (element === 'BROADBAND' && ((_a = _this.payload) === null || _a === void 0 ? void 0 : _a.broadBandSmbMonthlySaving) !== undefined) {
                            _this.savingsCardData.totalMonthlySavings =
                                Number(_this.payload.broadBandSmbMonthlySaving);
                        }
                    });
                }
                this.savingsCardData.totalOneTimeSavings =
                    this.payload.orderPriceInfo.totalOneTimeSavings;
                this.savingsCardData.hideTotalMonthlySavings = false;
                if ((this.payload.enablePlanModalFeature &&
                    this.payload.wirelessCart &&
                    this.payload.wirelessCart.planModalDetails &&
                    this.payload.wirelessCart.planModalDetails.planTotal &&
                    Number(this.payload.wirelessCart.planModalDetails.planTotal) > 0)
                    || (this.payload.wirelessCart &&
                        this.payload.wirelessCart.mixAndMatch)) {
                    this.savingsCardData.hideTotalMonthlySavings = true;
                }
            }
            var rewardsArr = this.getRewardsArr(this.payload);
            this.savingsCardData.rewardsArr = rewardsArr;
        }
    };
    PromoPanel.prototype.getCouponCodeArr = function () {
        var couponCodeArr = [];
        if (this.payload.wirelessCart
            && this.payload.wirelessCart.promotions) {
            couponCodeArr = __spreadArrays(couponCodeArr, this.payload.wirelessCart.promotions);
        }
        if (this.payload.broadbandCart
            && this.payload.broadbandCart.promotions) {
            couponCodeArr = __spreadArrays(couponCodeArr, this.payload.broadbandCart.promotions);
        }
        return couponCodeArr;
    };
    PromoPanel.prototype.getRewardsArr = function (payload) {
        var rewardsArr = [];
        if (payload.rewards) {
            rewardsArr = __spreadArrays(rewardsArr, payload.rewards);
        }
        return rewardsArr;
    };
    PromoPanel.prototype.initializeEvents = function () {
        var _this = this;
        this.promoCardEvents = {
            displayPanelError: this.displayPanelErr.bind(this),
            doLoading: this.props.events.doLoading,
            priceBarUpdates: this.checkAndpriceBarUpdates.bind(this),
        };
        this.yourSavingsCardEvents = {
            displayPanelError: this.displayPanelErr.bind(this),
            doLoading: this.props.events.doLoading,
        };
        this.messageEvents = {
            onClose: function () {
                _this.setState({ isPanelError: false });
            },
        };
        this.checkURLforCoupon = this.checkURLforCoupon.bind(this);
        this.applyCloserCoupon = this.applyCloserCoupon.bind(this);
        this.onClose = this.onClose.bind(this);
    };
    PromoPanel.prototype.getPromoContainer = function (promoPanelTexts) {
        var _this = this;
        var _a, _b, _c, _d;
        var isNewWireless = Utils.isNewWirelessFlow();
        var savingAndPromoPadding = isNewWireless ? promoStyles.promoLeftPadding : '';
        var isACPMsgShouldBeShown = !!(Utils.getIXPFlagValue('svc-show-acp-message'));
        return (React.createElement(ui_components_1.BasePanel, { testId: ui_components_1.BasePanel.name + '_SavingsPanel', options: basePanelOptions },
            React.createElement("div", { "data-test-id": PromoPanel.name, className: this.isExpUp ? styles.expupPromo : styles.container783w },
                React.createElement("div", { className: savingAndPromoPadding },
                    this.state.showMySaving &&
                        React.createElement("div", null,
                            !this.isExpUp &&
                                React.createElement("div", { className: [styles.iconDiv, styles.iconBg2].join(' ') },
                                    React.createElement("i", { "aria-label": "Icon", className: [icons.cccIconCart, icons.cccIconCartOffersL].join(' ') })),
                            this.isExpUp && React.createElement("div", { className: [styles.dividerLine, styles.mb15].join(' ') }),
                            React.createElement("div", { className: styles.secTitleDiv },
                                React.createElement("h2", { "data-test-id": utils_1.default('Message', 'Cart', 'MySaving'), className: this.isExpUp ? styles.expupspTitle : styles.spTitle }, promoPanelTexts.panelTitleLabel),
                                React.createElement("div", { style: { clear: 'both' } })),
                            React.createElement("div", { style: { clear: 'both' } })), (_b = (_a = this.props.data) === null || _a === void 0 ? void 0 : _a.losgData) === null || _b === void 0 ? void 0 :
                    _b.map(function (losgData) {
                        return _this.showRetailerOffer(losgData);
                    }),
                    this.state.isPanelError &&
                        React.createElement("div", { className: styles.pt20, style: { paddingBottom: 20 } },
                            React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Message', 'SavingsPanel_error'), onClose: this.onClose, type: "error" }, this.state.panelErrMsg)),
                    React.createElement("div", null,
                        (this.state.showMySaving || this.savingsCardData.promotionArr.length > 0
                            || this.savingsCardData.rewardsArr.length > 0) &&
                            React.createElement(YourSavingsCard_1.default, { "data-test-id": utils_1.default('Message', 'Cart', 'SavingContent'), data: this.savingsCardData, events: this.yourSavingsCardEvents, options: { isNewSavingsComponent: false } }),
                        (isACPMsgShouldBeShown && !CartUtils.getAcpEligibilityPromo()
                            && !CartUtils.isSMBCustomer() &&
                            (((_d = (_c = this.payload) === null || _c === void 0 ? void 0 : _c.broadbandCart) === null || _d === void 0 ? void 0 : _d.customerType) !== 'SMB')) &&
                            React.createElement("h4", { className: promoStyles.staticContent, "data-test-id": utils_1.default('Panel', 'Label', 'acpMessage') }, promoPanelTexts === null || promoPanelTexts === void 0 ? void 0 : promoPanelTexts.acpStaticContentMsg),
                        (this.state.showPromoCart ||
                            (this.state.autoApplyCouponCode && this.state.autoApplyCouponCode.couponCode)) &&
                            React.createElement(PromoCard_1.default, { data: { autoApplyCouponCode: this.state.autoApplyCouponCode }, events: this.promoCardEvents, options: {
                                    autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                                    isExpressUp: this.isExpUp,
                                } }))))));
    };
    PromoPanel.prototype.displayPanelErr = function (error, errorObj) {
        if (error) {
            this.setState({ isPanelError: true, panelErrMsg: errorObj.message });
        }
        else {
            this.setState({ isPanelError: false, panelErrMsg: '' });
        }
    };
    PromoPanel.prototype.checkAndpriceBarUpdates = function (isUpdate) {
        this.props.events.priceBarUpdates(isUpdate);
    };
    PromoPanel.prototype.checkURLforCoupon = function () {
        var url = location.href;
        var urlCouponCode = CartUtils.getUrlParamValue('couponcode', url);
        if (urlCouponCode) {
            this.setState({ autoApplyCouponCode: __assign(__assign({}, this.state.autoApplyCouponCode), { couponCode: urlCouponCode, focusOnPanel: true, source: 'URL' }) });
        }
    };
    PromoPanel.prototype.applyCloserCoupon = function (closerCoupon) {
        if (closerCoupon && closerCoupon.couponCode) {
            this.setState({ autoApplyCouponCode: __assign(__assign({}, this.state.autoApplyCouponCode), { couponCode: closerCoupon.couponCode, displayName: closerCoupon.displayName, focusOnPanel: true, legaltext: closerCoupon.legaltext, rewardsDetails: closerCoupon.rewardsDetails, rewardsamt: closerCoupon.rewardsamt, source: closerCoupon.triggerType }) });
        }
    };
    /*
      adding function for Alert onClose Event
    */
    PromoPanel.prototype.onClose = function () {
        this.setState({ isPanelError: false });
    };
    PromoPanel.wlsShowPromoPanelFlag = false;
    return PromoPanel;
}(React.Component));
exports.default = PromoPanel;
//# sourceMappingURL=PromoPanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/PromoPanel.js
// module id = 2239
// module chunks = 8